// extracted by mini-css-extract-plugin
export var dropdownIcon = "_n7-6";
export var imgContainer = "_n7-3";
export var menuIcon = "_n7-5";
export var pillWrapper = "_n7-2";
export var pillsContainer = "_n7-1";
export var subscriptionCard = "_n7-0";
export var subscriptionLogo = "_n7-4";